module.exports = __webpack_public_path__ + "menu_2_active_pc.955ecc71.png";